import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Error from '../pages/Error';
import Home from '../pages/Home';
import Contact from '../pages/Contact';
import About from '../pages/About';
import Legacy from '../pages/Legacy';
import Chartes from '../pages/Chartes';


const Roads = () => {
    const location = useLocation();
    return (
        <Routes location={location} key={location.key}>
            <Route path="/" element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legacy" element={<Legacy />} />
            <Route path="/chartes" element={<Chartes />} />

            <Route path='*' element={<Error />} />
        </Routes>
    )
}

export default Roads;